<template>
  <div id="app" class="min-h-screen bg-gray-50 dark:bg-gray-900">
    <Navigation />
    <main class="container mx-auto px-4 py-8">
      <RouterView />
    </main>
  </div>
</template>

<script setup lang="ts">
  import { onMounted } from 'vue';
  import { useWalletStore } from '@/stores/wallet';
  import Navigation from '@/components/Navigation.vue';

  const walletStore = useWalletStore();

  onMounted(() => {
    walletStore.initWalletListener();
    if (window.localStorage.getItem('wallet')) {
      walletStore.connect(window.localStorage.getItem('wallet') as string);
    }
  });
</script>
